import { EarningsSplit, KpiRow, NeedsAttention, PageHeader, RecentTransactions, RevenueChart, VendorTable } from './sections';

/**
 * Merchant dashboard (static sample data for now — see constants/merchantDashboardData.ts).
 * The profile lives in the header's top-right corner (components/dashboard/ProfileMenu.tsx).
 */
export function DashboardHomePage() {
  return (
    <div className="d-flex flex-column gap-4">
      <PageHeader />

      <KpiRow />

      <div className="row g-3">
        <div className="col-12 col-xl-8">
          <RevenueChart />
        </div>
        <div className="col-12 col-xl-4">
          <EarningsSplit />
        </div>
      </div>

      <div className="row g-3">
        <div className="col-12 col-xl-7">
          <VendorTable />
        </div>
        <div className="col-12 col-xl-5">
          <NeedsAttention />
        </div>
      </div>

      <RecentTransactions />
    </div>
  );
}
